'use strict';

exports.__esModule = true;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var attachEventToWindow = function attachEventToWindow(event1, event2, handler) {
    if (window.addEventListener) {
        window.addEventListener(event1, handler);
    } else {
        window.attachEvent(event2, handler);
    }
};
var detachEventFromWindow = function detachEventFromWindow(event1, event2, handler) {
    if (window.removeEventListener) {
        window.removeEventListener(event1, handler);
    } else {
        window.detachEvent(event2, handler);
    }
};

var WfAbstractComponent = function (_React$Component) {
    (0, _inherits3.default)(WfAbstractComponent, _React$Component);

    function WfAbstractComponent(props) {
        (0, _classCallCheck3.default)(this, WfAbstractComponent);

        var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

        _this.state = {
            width: 0
        };

        _this.onResize = _this.onResize.bind(_this);
        _this.sendSizeInfo = _this.sendSizeInfo.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        return _this;
    }

    WfAbstractComponent.prototype.onResize = function onResize() {};

    WfAbstractComponent.prototype.sendSizeInfo = function sendSizeInfo() {
        if (this.props.responsiveId) {
            var response = {
                responsiveId: this.props.responsiveId,
                height: document.querySelector('[data-reactroot]').offsetHeight
            };
            window.parent.postMessage((0, _stringify2.default)(response), '*');
        }
    };

    WfAbstractComponent.prototype.componentDidMount = function componentDidMount() {
        if (this.props.responsiveId !== undefined) {
            this.sendSizeInfo();
            attachEventToWindow('message', 'onmessage', this.sendSizeInfo);
        }

        this.setState({
            width: this.getWidth()
        });

        attachEventToWindow('resize', 'onresize', this.handleWindowResize);
    };

    WfAbstractComponent.prototype.componentDidUnmount = function componentDidUnmount() {
        if (this.props.responsiveId !== undefined) {
            detachEventFromWindow('message', 'onmessage', this.sendSizeInfo);
        }

        detachEventFromWindow('resize', 'onresize', this.handleWindowResize);
    };

    WfAbstractComponent.prototype.getWidth = function getWidth() {
        return document.querySelector('[data-reactroot]').offsetWidth;
    };

    WfAbstractComponent.prototype.handleWindowResize = function handleWindowResize() {
        this.setState({
            width: this.getWidth()
        });
    };

    WfAbstractComponent.prototype.render = function render() {};

    return WfAbstractComponent;
}(_react2.default.Component);

exports.default = WfAbstractComponent;